module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_8004.d3885eba.png";